export const FEATURE_NAME = '@vshosting/cdn/features/purge-cache-dialog';
